// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8 4.05C8 2.69 7.03 1.7 5.77 1.7C4.54 1.7 3.6 2.63 3.6 3.8C2.31 4.12 1.55 5.18 1.55 6.47C1.55 7.23 1.84 7.9 2.32 8.42C1.87 8.95 1.65 9.58 1.65 10.25C1.65 11.68 2.7 12.8 4.06 12.96C4.39 13.84 5.17 14.3 6.13 14.3C7.2 14.3 8 13.48 8 12.4C8 13.48 8.8 14.3 9.87 14.3C10.83 14.3 11.61 13.84 11.94 12.96C13.3 12.8 14.35 11.68 14.35 10.25C14.35 9.58 14.13 8.95 13.68 8.42C14.16 7.9 14.45 7.23 14.45 6.47C14.45 5.18 13.69 4.12 12.4 3.8C12.4 2.63 11.46 1.7 10.23 1.7C8.97 1.7 8 2.69 8 4.05V12.4',
  'M3.6 3.8C3.6 4.92 4.47 5.8 5.57 5.8',
  'M12.4 3.8C12.4 4.92 11.53 5.8 10.43 5.8',
  'M4.06 12.96C4.67 12.27 4.84 11.23 4.4 10.42',
  'M11.94 12.96C11.33 12.27 11.16 11.23 11.6 10.42',
];
